import Sprite from '../../Sprite';
import Point from 'Utility/Point';
import AnimationComponent from 'Component/Animation';
import Container from '../../Container';
import GameObject from 'GameObject/GameObject';
import Game from 'Game';

export default class Scissor extends Container {
    public onCreate(params: any): void {
        params = {
            playOnStart: true,
            clipName: 'ScissorsIdle',
            ...params,
        };

        super.onCreate({
            name: 'scissorsContainer',
            scale: new Point(0.8, 0.8),
        });

        this.addChild(
            GameObject.Instantiate(Sprite, {
                name: 'crabSprite',
                texture: 'scissors_1',
                anchor: new Point(0.5, 0.5),
            })
        );

        this.addComponent(AnimationComponent, params);
    }
    
    public static async preload(): Promise<void> {
        Game.resource.add(
            'RopeAndScissors_Audio',
            'resource/audio/RopeAndScissors.mp3'
        );
    }
}
